import { forwardRef, useMemo } from "react";
import {
  FormLabel,
  TablePagination,
} from "@mui/material";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { GenerateAnexarDocumentosColumnDefinition } from "../columns/AnexarDocumentos";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { DocumentosPaginationStore } from "../../../hooks/Projetos_Arquivo/pagination";
import { DocumentoLista } from "../../../../domain/models/documentos_lista";

type Props = {
  loading: boolean;
  documentos: DocumentoLista[];
  paginationDocumentos: DocumentosPaginationStore;
  handleDocumento: () => void;
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
  onActionDownload: (id: number, imageName: string) => void;
  handleRowsPerTableDocChange: (rowsPerPage: number) => void;
  handleTableDocChange: (page: number) => Promise<void>;
};

export const AnexarDocumentosContent = forwardRef<HTMLButtonElement, Props>(
  ({ documentos, paginationDocumentos, loading, handleDocumento, onActionEditar, onActionDeletar, onActionDownload, handleRowsPerTableDocChange, handleTableDocChange }: Props, ref) => {

    const columnsDefinitionDocumentos = useMemo(() => {
      return GenerateAnexarDocumentosColumnDefinition({
        onActionDeletar: onActionDeletar,
        onActionEditar: onActionEditar,
        onActionDownload: onActionDownload,
      },);
    }, [onActionDeletar, onActionDownload, onActionEditar]);

    return (
      <>
        <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border border-border-light-mode dark:border-border-dark-mode mb-4">
          <div className="w-full justify-between flex gap-2">
            <FormLabel className="flex-shrink-0">Anexar Documento</FormLabel>
            <div className="mb-4">
              <PrimaryButton startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />} onClick={handleDocumento}>
                Novo
              </PrimaryButton>
            </div>
          </div>

          <StyledDataGrid
            autoHeight={true}
            tableName="Item Checklist"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: DocumentoLista) => row.IdProjetoArquivo ?? ""}
            columns={columnsDefinitionDocumentos}
            loading={loading}
            checkboxSelection={false}
            rows={documentos}
            rowCount={paginationDocumentos.totalItems}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: paginationDocumentos.page,
              pageSize: paginationDocumentos.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["IdProjetoArquivo"],
            }}
          />

          <TablePagination
            component="div"
            count={paginationDocumentos.totalItems}
            page={paginationDocumentos.page - 1}
            onPageChange={(_, p) => handleTableDocChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={paginationDocumentos.rowsPerPage}
            onRowsPerPageChange={(e) => handleRowsPerTableDocChange(parseInt(e.target.value))}
          />

        </div>
      </>
    );
  },
);
